import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TablePagination from "@material-ui/core/TablePagination";
import swal from "sweetalert";
import { _get } from "../Api";
import { useParams } from "react-router-dom";
import TablePaginationActions from "../components/TablePaginationActions/TablePaginationActions";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
  tableContainer: {
    width: "auto",
    overflow: "hidden",
  },
  tablePagination: {
    position: "absolute",
    bottom: 10,
    right: 20,
    backgroundColor: "white",
    border: "1px solid #DDD",
    padding: "1px",
  },
  toolbar: {
    minHeight: "30px",
  },
}));

export default function MerchantLogs() {
  const classes = useStyles();
  const params = useParams();
  const merchantId = Number.parseInt(params.merchantId);
  const [loading, setLoading] = React.useState(true);
  const [logs, setLogs] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  if (loading) {
    _get(`/nova/v2/merchant/${merchantId}/logs?page=${page}&number_per_page=${rowsPerPage}`)
      .then((result) => {
        setLogs(result.data);
      })
      .catch((e) => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
        console.log(e);
      });
    setLoading(false);
  }

  const handleChangePage = (event, newPage) => {
    setLoading(true);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLoading(true);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const renderRow = logs.reduce((rows, log) => {
    const length = rowsPerPage;
    const index = logs.indexOf(log);
    if (index !== length) {
      rows.push(
        <ListItem key={log.id}>
          <TableContainer className={classes.tableContainer} component={Paper}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell padding="none" align="right">
                    <span style={{ fontSize: "10px", fontWeight: "bold", padding: "10px" }}>Created At</span>
                  </TableCell>
                  <TableCell padding="none" align="left">
                    <span style={{ fontSize: "10px", padding: "10px" }}>
                      {new Date(log.created_at).toLocaleString()}
                    </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell padding="none" align="right">
                    <span style={{ fontSize: "10px", fontWeight: "bold", padding: "10px" }}>Extra</span>
                  </TableCell>
                  <TableCell padding="none" align="left" style={{ padding: "10px" }}>
                    <span style={{ fontSize: "10px" }}> {JSON.stringify(log.data)}</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </ListItem>
      );
    }
    return rows;
  }, []);

  return (
    <div>
      <Typography variant="h4">Merchant Logs</Typography>
      <TableContainer>
        <Table size="large" aria-label="a dense table">
          <TableBody>
            <List itemSize={46} itemCount={200}>
              {renderRow}
            </List>
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.tablePagination}
        classes={{ toolbar: classes.toolbar }}
        rowsPerPageOptions={[10, 25, 50, 100]}
        labelDisplayedRows={() => `Page: ${page + 1}`}
        count={logs.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </div>
  );
}
